import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { AdminAlertsList } from '@components/templates/admin/alerts';

export const AlertsPage = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('admin.alerts-page.metatags.title'),
        description: t('admin.alerts-page.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.alerts,
        index: false,
    });

    return <AdminAlertsList />;
};
